import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Lock, Check, Zap } from 'lucide-react';

export const TradeUnlockModal = ({ trade, summary, onClose }) => {
  const navigate = useNavigate();
  if (!trade) return null;

  const info = (summary?.trades || []).find((t) => t.trade === trade) || {};
  const monthly = summary?.monthly_per_trade || 497;
  const annual = summary?.annual_per_trade || 4970;

  const go = (plan, trades) => navigate(`/checkout?plan=${plan}&trades=${trades.join(',')}`);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={onClose} data-testid="trade-unlock-modal">
      <div className="bg-card-bg border border-divider rounded-2xl max-w-lg w-full p-8 relative" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} data-testid="trade-unlock-close" className="absolute top-4 right-4 text-gray hover:text-white"><X size={22} /></button>

        <div className="flex items-center gap-3 mb-2">
          <div className="w-12 h-12 rounded-xl bg-orange/15 border border-orange/40 flex items-center justify-center">
            <Lock className="text-orange" size={22} />
          </div>
          <h2 className="text-2xl md:text-3xl font-black text-white uppercase" data-testid="trade-unlock-title">
            Unlock the {trade} Vault
          </h2>
        </div>

        <p className="text-light-gray mb-6" data-testid="trade-unlock-counts">
          Get instant access to <span className="text-lime font-bold">{info.campaign_count || 0} done-for-you {trade} campaigns</span> with{' '}
          <span className="text-lime font-bold">{(info.asset_count || 0).toLocaleString()} ready-to-launch assets</span> — ads, emails, SMS, phone scripts, landing page copy and more.
        </p>

        <div className="space-y-3">
          <button
            onClick={() => go('monthly', [trade])}
            data-testid="trade-unlock-monthly-btn"
            className="w-full text-left p-5 rounded-xl border border-divider bg-black hover:border-orange/60 transition-colors"
          >
            <div className="flex items-center justify-between gap-3">
              <div>
                <p className="text-white font-bold text-lg flex items-center gap-2"><Check size={17} className="text-orange" /> Add {trade} — Monthly</p>
                <p className="text-sm text-light-gray mt-1">Cancel anytime, no lock-in</p>
              </div>
              <span className="text-white font-black text-2xl whitespace-nowrap">${monthly.toLocaleString()}<span className="text-sm text-gray font-bold">/mo</span></span>
            </div>
          </button>

          <button
            onClick={() => go('annual', [trade])}
            data-testid="trade-unlock-annual-btn"
            className="w-full text-left p-5 rounded-xl border-2 border-lime bg-lime/10 hover:bg-lime/15 transition-colors relative"
          >
            <span className="absolute -top-3 right-4 px-3 py-0.5 rounded-full bg-lime text-black text-xs font-black uppercase">2 Months Free</span>
            <div className="flex items-center justify-between gap-3">
              <div>
                <p className="text-white font-bold text-lg flex items-center gap-2"><Zap size={17} className="text-lime" /> Add {trade} — Yearly</p>
                <p className="text-sm text-light-gray mt-1">Less than one month of an agency retainer.</p>
              </div>
              <span className="text-lime font-black text-2xl whitespace-nowrap">${annual.toLocaleString()}<span className="text-sm font-bold">/yr</span></span>
            </div>
          </button>

          <button
            onClick={() => go('monthly', ['HVAC', 'Plumbing', 'Electrical'])}
            data-testid="trade-unlock-bundle-btn"
            className="w-full text-left p-4 rounded-xl border border-orange/40 bg-orange/5 hover:bg-orange/10 transition-colors"
          >
            <p className="text-orange font-bold text-sm">Want everything? Unlock all 3 trades — ${(monthly * 3).toLocaleString()}/mo or ${(annual * 3).toLocaleString()}/yr →</p>
          </button>
        </div>

        <p className="text-xs text-gray mt-4 text-center">Secure Stripe checkout · Unlocks instantly after payment</p>
      </div>
    </div>
  );
};
